<template>
  <div id="LaptopFlagged">
    <div v-if="isLoaded" class="content">
      <div class="title">
        <Row>
          <Column :sm="8" :xs="6">
            <h2>
              {{ $t('title') }}
            </h2>
            <div>
              {{ laptop.name }}
            </div>
          </Column>
          <Column v-if="isLoaded" :sm="4" :xs="6">
            <Row>
              <Column :md="6">
                <Route
                  :id="recordId"
                  class="Btn"
                  to="Laptop">
                  {{ $t('linkToLaptop') }}
                </Route>
              </Column>
              <Column :md="6">
                <a
                  class="Btn"
                  :href="laptop.link"
                  target="_blank">
                  {{ $t('linkToAmazon') }}
                </a>
              </Column>
            </Row>
          </Column>
        </Row>
      </div>
      <div class="articles">
        <Row>
          <Column
            v-for="articleLaptopWithArticle in articleLaptopsWithArticles"
            :key="articleLaptopWithArticle.article.id"
            :lg="3"
            :md="4">
            <ArticleContainingLaptop
              :articleLaptopWithArticle="articleLaptopWithArticle"
              :currentPrice="laptop.price"
              :laptopId="laptop.id" />
          </Column>
        </Row>
      </div>
    </div>
    <Empty v-else>
      <Loader class="lg info" />
      {{ $t('loading') }}
    </Empty>
  </div>
</template>

<script>
import { actions, getters } from '@utils'
import ArticleContainingLaptop from './components/ArticleContainingLaptop'
import { pluckId } from '@utils/collections'

export default {
  components: { ArticleContainingLaptop },
  computed: {
    recordId() {
      return Number(this.$route.params.id)
    },
    laptop() {
      return this.queryOne('laptop', this.recordId)
    },
    articleLaptops() {
      return this.query('articleLaptop', { laptopId: this.recordId, isPriceCorrect: false })
    },
    articleIdsContainingLaptop() {
      return pluckId(
        'articleId',
        this.articleLaptops,
      )
    },
    articlesContainingLaptop() {
      return this.query('article', {
        id: {
          $in: this.articleIdsContainingLaptop,
        },
      })
    },
    articleLaptopsWithArticles() {
      return this.articleLaptops.map(articleLaptop => {
        const article = this.articlesContainingLaptop
          .find(article => article.id === articleLaptop.articleId)

        return {
          articleLaptop,
          article,
        }
      })
    },
    ...getters(),
  },
  methods: {
    ...actions(
      'FETCH_ARTICLE',
      'FETCH_LAPTOP',
      'FETCH_ARTICLE_LAPTOP',
    ),
  },
  beforeMount() {
    this.LOAD(async () => {
      await this.FETCH_LAPTOP(this.recordId)
      await this.FETCH_ARTICLE_LAPTOP({
        laptopId: this.recordId,
        isPriceCorrect: false,
      })
      await this.FETCH_ARTICLE({
        id: {
          $in: this.articleIdsContainingLaptop,
        },
      })
    })
  },
}
</script>

<style lang="scss">
#LaptopFlagged {
  .content {
    > .title {
      background: $white-bis;
      padding: $grid-unit;
      @include md {
        .Btn span.add {
          display: inline-block;
        }
      }

      h2 {
        @include ellipsis;
        font-size: $h2;
        margin-bottom: $grid-unit;
        text-transform: none;
      }

      .Btn span.add {
        display: none;
      }
    }

    .articles {
      .ArticleContainingLaptop {
        margin: 1rem 0 1rem 1rem;
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Articles Containing Laptop",
    "linkToAmazon": "Link to Amazon",
    "linkToLaptop": "Go to Laptop",
    "loading": "Loading"
  }
}
</i18n>
